<template>
  <div class="lxm-contact-list">

    <div class="page">
      <div v-if="tagName" class="lxm-contact-list__tag">
        <lxm-tag :color="tagColor" :text="tagName"></lxm-tag>
      </div>

      <transition-group name="lxm-content-transition" tag="div" mode="out-in">
        <lxm-contact-item v-for="item in items"
                          :key="item"
                          :id="item.id"
                          :org="item.org"
                          :name="item.name"
                          :phone="item.phone"
                          :avatar="item.avatar"
                          :isFemale="item.isFemale"></lxm-contact-item>
      </transition-group>
      <div v-if="isOne" class="lxm-contact-list__one">登录灵析电脑版，可以为联系人分类哦～</div>
      <lxm-more v-if="hasMore" :loading="loading" @click="moreClicked"></lxm-more>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-contact-list__tag
    margin-bottom: spacing-small
  .lxm-contact-list__one
    margin-top siz(20)
    font-size 14px
    color cloudy
    text-align center
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmTag from '../common/LxmTag.vue'
  import LxmContactItem from '../common/LxmContactItem.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmBottomTabs from '../common/LxmBottomTabs.vue'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmNav,
      LxmTag,
      LxmContactItem,
      LxmMore,
      LxmBottomTabs
    },
    props: {
      orgId: {
        type: String,
        default: ''
      }
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_LIST]
      },
      currentPage () {
        return this.tagName ? this.$store.state.contact.tagged.currentPage : this.$store.state.contact.currentPage
      },
      hasMore () {
        return this.tagName ? this.$store.state.contact.tagged.hasMore : this.$store.state.contact.hasMore
      },
      items () {
        return this.tagName ? this.$store.state.contact.tagged.list : this.$store.state.contact.list
      },
      tagName () {
        return this.$route.query.tagName
      },
      tagColor () {
        return this.$route.query.tagColor
      },
      isOne () {
        return this.$store.state.contact.list.length === 1
      }
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      this.getFirstPage()
    },
    methods: {
      getFirstPage () {
        if ((!this.tagName && !this.$store.state.loaded.contact.list) ||
        this.tagName && (this.$store.state.loaded.contact.taggedList.roleId !== this.$route.query.roleId || this.$store.state.loaded.contact.taggedList.tagId !== this.$route.query.tagId) ||
        (this.orgId && this.orgId !== this.$store.state.loaded.contact.taggedList.orgId)) {
          this.$store.dispatch(aTypes.CONTACT_GET_LIST, {
            page: 1,
            append: false,
            orgId: this.orgId,
            withRelation: 'org',
            tagId: this.$route.query.tagId,
            roleId: this.$route.query.roleId
          })
        }
      },
      moreClicked () {
        this.$store.dispatch(aTypes.CONTACT_GET_LIST, {
          append: true,
          orgId: this.orgId,
          withRelation: 'org',
          page: this.currentPage + 1,
          tagId: this.$route.query.tagId,
          roleId: this.$route.query.roleId
        })
      }
    },
    watch: {
      $route () {
        this.getFirstPage()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?70cacd6a